(function (win) {
  'use strict';
  var timers = new WeakMap();
  function cancel(node) {
    if (!node) return;
    win.clearTimeout(timers.get(node)); timers.delete(node);
    node.removeAttribute('data-content-feedback');
  }
  function begin(node) {
    if (!node) return;
    cancel(node); node.hidden = false;
    node.setAttribute('data-content-feedback', 'loading');
  }
  function finish(node, after) {
    if (!node) { if (after) after(); return; }
    cancel(node); node.hidden = false;
    node.setAttribute('data-content-feedback', 'complete');
    timers.set(node, win.setTimeout(function () {
      timers.delete(node); node.removeAttribute('data-content-feedback');
      if (node.isConnected && after) after();
    }, 650));
  }
  win.EnigmaContentFeedback = { begin: begin, finish: finish, cancel: cancel };
})(window);
